$(document).ready(function () {
  $(".backtotop__link").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 1000);
  });

  $(document).on("click", ".custom-orders", function (event) {
    event.preventDefault();
    $(".order-content").toggle();
  });

  $(document).on("keyup", ".site-header__search-input", function () {
    var inputVal = $(this).val();
    if (inputVal == "") {
      $(".clear-text").removeClass("cleartext");
    } else {
      $(".clear-text").addClass("cleartext");
    }
  });

  $(document).on("click", ".clear-text", function () {
    $(this).removeClass("cleartext");
  });

  let delivery_country = document.querySelector(".country_Selector");
  if(delivery_country){
  delivery_country.addEventListener("change", function (evt) {
    document.querySelectorAll(".shipping_info").forEach((item, index) => {
      item.classList.add("custom_hidden");
    });
    document
      .querySelectorAll(`.${evt.currentTarget.value}`)
      .forEach((item, index) => {
        item.classList.remove("custom_hidden");
      });
  });
  }

  customSlick();
  productCarousel()
});
$("body")
  .on("click", "#size-chart", function () {
    let size_chart = $(this).attr("data-vendor");
    $(".size--chart").removeClass("hidden");
    $("body").addClass("custom--body");
    if ($(`.${size_chart}`).length > 0) {
      $(`.${size_chart}`).removeClass("hidden");
    } else {
      $(".general-size-guide").removeClass("hidden");
    }
  })
  .on("click", ".custom--close", function () {
    $(".size--chart,.custom--popup").addClass("hidden");
    $("body").removeClass("custom--body");
  })
  .on("change", "#country_wrapper", function () {
    let country_selector = $(this).val();
    columnStatus(country_selector);
  }).on("click",".show_more",function(event){
    event.stopPropagation();
    $(this).prev().children('.li-element').toggleClass('hide');
    $(this).children('span.text_msg').toggleClass('hide');
    $(this).parents('.collapsible-content--sidebar.is-open').attr('style','height:auto');
    console.log($(this).prev().children('.li-element').length);
}).on("click","#SearchClose",function(){
    $(this).parents(".site-header__search-container").removeClass("is-active");
})
columnStatus("us_international");
function columnStatus(country_selector) {
  $(".size-guide table tr").each(function () {
    if (
      $(this).children('[data-country="aus"]').index() >= 0 ||
      $(this).children('[data-country="eu"]').index() >= 0 ||
      $(this).children('[data-country="uk"]').index() >= 0
    ) {
      let $table = $(this).parents("table");
      var aus = $(this).children('[data-country="aus"]').index();
      var eu = $(this).children('[data-country="eu"]').index();
      var uk = $(this).children('[data-country="uk"]').index();
      var selectedColumn = $(this)
        .children(`[data-country=${country_selector}]`)
        .index();
      $table
        .find("tbody tr, thead tr")
        .children(":nth-child(" + (aus + 1) + ")")
        .hide();
      $table
        .find("tbody tr, thead tr")
        .children(":nth-child(" + (eu + 1) + ")")
        .hide();
      $table
        .find("tbody tr, thead tr")
        .children(":nth-child(" + (uk + 1) + ")")
        .hide();
      $table
        .find("tbody tr, thead tr")
        .children(":nth-child(" + (selectedColumn + 1) + ")")
        .show();
    }
  });
}
function customSlick(){
  $('.slider').not('.slick-initialized').slick({ 	
    dots: false,
    arrows:true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay:false,
    prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width='15' height='12' viewBox='0 0 6.591 11.061'><path d='M0,10,5,5,0,0' transform='translate(6.061 10.53) rotate(180)' fill='none' stroke='#383838' stroke-width='1.5'></path></svg></button>`,
    nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width='15' height='12' viewBox='0 0 6.591 11.061'><path d='M0,10,5,5,0,0' transform='translate(0.53 0.53)' fill='none' stroke='#383838' stroke-width='1.5'></path></svg></button>`,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }

    ]
  });
}

function productCarousel() {
  // Initialize the thumbnails slider
  const thumbSlides = document.querySelectorAll('.product-image-nav-slider .swiper-slide');
  const thumbSlider = $('.product-image-nav-container');

  const thumbsSwiper = new Swiper(".product-image-nav-slider", {
    spaceBetween: 4,
    slidesPerView: 5,
    direction: 'horizontal',
    loop: thumbSlides.length > 5,
    freeMode: true,
    //watchSlidesProgress: true,
    navigation: {
      nextEl: ".product__thumb-arrow--next",
      prevEl: ".product__thumb-arrow--prev"
    },
    runCallbacksOnInit: true,
    on: {
      init: function() {
        thumbSlider.addClass('active');
      }
    },
    breakpoints: {
      768: {
        direction: 'vertical',
        spaceBetween: 0
      },
    }
  });

  // Initialize the main slider
  const mainSwiper = new Swiper(".product-image-slider", {
    spaceBetween: 10,
    slidesPerView: 1,
    loop: thumbSlides.length > 2,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: thumbsSwiper,
      multipleActiveThumbs: false
    },
    on: {
      slideChangeTransitionEnd: function() {
        const currentSlide = mainSwiper.slides[mainSwiper.activeIndex];
        const videos = currentSlide.querySelectorAll('video');

        videos.forEach(video => {
          if (video.hasAttribute('data-video-style')) {
            video.play();
          }
        });
      }
    },
    breakpoints: {
      1275: {
        spaceBetween: 10,
        slidesPerView: 2
      }
    }
  });
  
  document.dispatchEvent(new CustomEvent('mainSwiper:ready', { detail: { mainSwiper }}));

  // Handle thumbnail hover
  thumbSlides.forEach((slide, index) => {
    slide.addEventListener('mouseenter', () => {
      setTimeout(() => {
        mainSwiper.slideToLoop(index)
      }, 30);
    });
  });
}

/**
 * Reusable utility to initialize a product carousel with Swiper
 * @param {Object} options - Configuration options
 * @param {string} options.containerSelector - Swiper container selector
 * @param {string} options.nextSelector - Next button selector
 * @param {string} options.prevSelector - Previous button selector
 * @param {number} options.slidesPerView - Default slides per view (mobile)
 * @param {number} options.slidesPerViewTablet - Slides per view on tablet
 * @param {number} options.slidesPerViewDesktop - Slides per view on desktop
 * @param {number} options.spaceBetween - Space between slides
 * @param {boolean} options.enableLoop - Enable loop mode
 * @param {Function} options.onInit - Callback on initialization
 * @param {Function} options.onResize - Callback on resize
 * @returns {Swiper} Swiper instance
 */
window.initProductCarousel = function(options) {
  const defaults = {
    containerSelector: null,
    nextSelector: null,
    prevSelector: null,
    slidesPerView: 2,
    slidesPerViewTablet: 3,
    slidesPerViewDesktop: 4,
    spaceBetween: 15,
    spaceBetweenTablet: 25,
    spaceBetweenDesktop: 30,
    enableLoop: false,
    onInit: null,
    onResize: null
  };

  const config = Object.assign({}, defaults, options);

  if (!config.containerSelector) {
    console.error('initProductCarousel: containerSelector is required');
    return null;
  }

  const swiperEl = document.querySelector(config.containerSelector);
  if (!swiperEl) {
    console.error(`initProductCarousel: Container ${config.containerSelector} not found`);
    return null;
  }

  // Remove loading class if present
  swiperEl.classList.remove('collection-carousel-swiper-loading');

  // Determine if loop should be enabled based on slide count
  const slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;
  const shouldLoop = config.enableLoop && slidesCount > config.slidesPerViewDesktop;

  // Helper function to center items if fewer than slides per view
  function updateCenteredClass(swiper) {
    const slidesCount = swiper.slides.length;
    const slidesPerView = swiper.params.slidesPerView;
    
    if (slidesCount < slidesPerView) {
      swiper.wrapperEl.style.justifyContent = 'center';
    } else {
      swiper.wrapperEl.style.justifyContent = '';
    }
  }

  // Build Swiper configuration
  const swiperConfig = {
    slidesPerView: config.slidesPerView,
    spaceBetween: config.spaceBetween,
    loop: shouldLoop,
    breakpoints: {
      540: {
        slidesPerView: config.slidesPerView,
        spaceBetween: config.spaceBetween + 5
      },
      768: {
        slidesPerView: config.slidesPerViewTablet,
        spaceBetween: config.spaceBetweenTablet
      },
      1024: {
        slidesPerView: config.slidesPerViewDesktop,
        spaceBetween: config.spaceBetweenDesktop
      }
    },
    on: {
      init: function() {
        updateCenteredClass(this);
        if (config.onInit) {
          config.onInit(this);
        }
      },
      resize: function() {
        updateCenteredClass(this);
        if (config.onResize) {
          config.onResize(this);
        }
      }
    }
  };

  // Add navigation if selectors provided
  if (config.nextSelector && config.prevSelector) {
    swiperConfig.navigation = {
      nextEl: config.nextSelector,
      prevEl: config.prevSelector,
    };
  }

  // Initialize Swiper
  const swiper = new Swiper(config.containerSelector, swiperConfig);

  return swiper;
};

